const InternalUtilities = {
  getTTCLID() {
    const ttclid = sessionStorage.getItem("ttclid");
    if (ttclid) {
      return ttclid;
    } else if (new URLSearchParams(window.location.search).get("ttclid")) {
      return new URLSearchParams(window.location.search).get("ttclid");
    }
    return null;
  },
  storeTTCLID() {
    const params = new URLSearchParams(window.location.search);
    const ttclid = params.get("ttclid");
    if (ttclid) {
      sessionStorage.setItem("ttclid", ttclid);
    }
  },
  removeTTCLID() {
    sessionStorage.removeItem("ttclid");
  },
};

export default InternalUtilities;
